import { Action } from '@ngrx/store';

export enum WeightMeterActionTypes {
    WEIGHT_METER_EDIT = '[WEIGHT_METER] WeightMeterEdit',
    WEIGHT_METER_EDITED = '[WEIGHT_METER] WeightMeterEdited',
    WEIGHT_METER_ADD = '[WEIGHT_METER] WeightMeterAdd',
    WEIGHT_METER_ADDED = '[WEIGHT_METER] WeightMeterAdded',
    WEIGHT_METER_DELETE = '[WEIGHT_METER] WeightMeterDelete',
    WEIGHT_METER_DELETED = '[WEIGHT_METER] WeightMeterDeleted',
    WEIGHT_METER_GET_PAGE = '[WEIGHT_METER] WeightMeterGetPage',
    WEIGHT_METER_PAGE_LOADED = '[WEIGHT_METER] WeightMeterPageLoaded',
    WEIGHT_METER_GET_ALL = '[WEIGHT_METER] WeightMeterGetAll',
    WEIGHT_METER_ALL_LOADED = '[WEIGHT_METER] WeightMeterAllloaded'
}

export class WeightMeterAdd implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_ADD;
    constructor(public payload: any) {}
}

export class WeightMeterEdit implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_EDIT;
    constructor(public payload: any) {}
}

export class WeightMeterGetPage implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_GET_PAGE;
    constructor(public payload: any) {}
}

export class WeightMeterPageLoaded implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_PAGE_LOADED;
    constructor(public payload: any) {}
}

export class WeightMeterAdded implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_ADDED;
    constructor(public payload: any) {}
}

export class WeightMeterEdited implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_EDITED;
    constructor(public payload: any) {}
}

export class WeightMeterDelete implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_DELETE;
    constructor(public payload: any) {}
}

export class WeightMeterDeleted implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_DELETED;
    constructor(public payload: any) {}
}

export class WeightMeterGetAll implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_GET_ALL;
    constructor(public payload: any) {}
}

export class WeightMeterAllLoaded implements Action {
    readonly type = WeightMeterActionTypes.WEIGHT_METER_ALL_LOADED;
    constructor(public payload: any) {}
}

export type WeightMeterActions =
                | WeightMeterAdd
                | WeightMeterEdit
                | WeightMeterGetPage
                | WeightMeterPageLoaded
                | WeightMeterAdded
                | WeightMeterDeleted
                | WeightMeterDelete 
                | WeightMeterEdited
                | WeightMeterGetAll
                | WeightMeterAllLoaded;